{
  "manager": {
    "userList": {
      "addUser": "Add User",
      "memberId": "Member ID",
      "userAddedSuccess": "User added successfully",
      "userAddFailed": "Failed to add user",
      "userRemovedSuccess": "User removed successfully",
      "userRemoveFailed": "Failed to remove user",
      "userLoadFailed": "Failed to load users"
    },
    "boundaryCreateContainer": {
      "editInstructions": "To edit a boundary click \"Reset Boundary\" then create your updated boundary by clicking around the area on the map. Then click \"Save\" and exit.",
      "title": "Title",
      "titlePlaceholder": "Enter a title for your boundary",
      "drawBoundary": "Draw Boundary",
      "updateHeading": "Update Boundary",
      "createHeading": "Create Boundary",
      "updatedToast": "Boundary updated!",
      "createdToast": "Boundary created!"
    },
    "boundaryMap": {
      "resetBoundary": "Reset Boundary"
    },
    "organizationFiles": {
      "files": "Files",
      "upload": "Upload"
    },
    "simpleOrganizationSearch": {
      "searchPlaceholder": "Search by email or name",
      "changeSelection": "Change Selection"
    },
    "organizationIndex": {
      "title": "Organizations"
    },
    "organizationSearch": {
      "searchLabel": "Search for an Organization *",
      "requiredFeedback": "This field is required.",
      "searchPlaceholder": "Search for an organization"
    },
    "inputOrganizationSearch": {
      "searchPlaceholder": "Search by name, email, or contact",
      "selectedLabel": "Selected Organizations:",
      "idLabel": "ID:",
      "contactLabel": "Contact:",
      "noResults": "No organizations found for \"{query}\""
    },
    "organizationCreate": {
      "nameLabel": "Organization Name *",
      "namePlaceholder": "Enter the name of the organization",
      "contactNameLabel": "Contact Name *",
      "contactNamePlaceholder": "Enter a contact name",
      "contactEmailLabel": "Contact Email *",
      "contactEmailPlaceholder": "Enter an email",
      "contactPhoneLabel": "Contact Phone Number",
      "contactPhonePlaceholder": "Enter a phone number",
      "editTitle": "Edit Organization",
      "createTitle": "Create Organization",
      "entity": "Organization"
    },
    "organizationShow": {
      "detailsHeader": "ORGANIZATION DETAILS",
      "noBookings": "This organization does not have any associated bookings yet.",
      "confirmDeletePrefix": "Are you sure you would like to delete",
      "thisOrganizationFallback": "this organization",
      "entity": "Organization",
      "archivedSuccess": "Successfully archived",
      "pageTitle": "View Organization",
      "tabDetails": "Details",
      "tabPeople": "People",
      "tabInvoices": "Invoices",
      "tabBookings": "Associated Bookings",
      "tabNotes": "Notes",
      "tabFiles": "Files"
    },
    "childFeeTable": {
      "title": "Configure Fee Enablement"
    },
    "childProfileFieldTable": {
      "title": "Exclude From Parent Profile Fields"
    }
  }
}
